<template>
  <div>
    <base-header pageName="명함보기" :popup="true"></base-header>
    <section id="wrap">
      <iframe :src="profileUrl+userId" style="overflow-x:hidden; overflow:auto; width:100%; min-height:865px;"></iframe>
      <input type="text" v-model="telNo" placeholder="휴대폰번호 입력" maxlength="11"
        oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"/>
      <button @click="sendKakaoTalk">명함발송</button>
      <button @click="goKss">명함수정</button>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {      
      userId: '',
      profileUrl : 'http://morder.kyowon.co.kr/ptt/mcard/',
      telNo:'',

    };
  },
  methods: {
    sendKakaoTalk(){
      if(!this.telNo){
        alert("발송할 고객의 휴대폰번호를 입력해주세요.");
        return;
      }
      
      var regExp = /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/;
      if(!regExp.test(this.telNo)){
        alert("전화번호를 확인해주세요.");
        return;
      }
      
      var that = this;
      //카카오톡발송.. // 안되면 SMS??
      this.$api.dashboard
      .sendProfile({telNo : this.telNo})
      .then(function () {
          alert("명함이 발송되었습니다.");
          that.telNo = "";
      })
      .catch(function (error) {
          alert(error.rtMsg);
      });  
    },
    goKss(){
      var that = this;
      var url = '/pioneer/callingCardMk';

      this.$api.dashboard
      .getSsoToken()
      .then(function (data) {
        if(data && data.token && data.userIdEnc){
          var ssoUrl = 'http://ksos.kyowon.co.kr?';
          ssoUrl += 'userId='+data.userIdEnc+'&token='+data.token+'&path='+url;
          console.log(ssoUrl)
          that.$utils.nativeIf.outbound.outlink(ssoUrl)
        }else{
          // alert("SSO연동에 실패 하였습니다.")
          that.$utils.nativeIf.outbound.outlink("https://ksos.kyowon.co.kr"+url);
        }
      })
      .catch(function (error) {
          alert(error.rtMsg);
      });
    }
  },
  created: function () {
    this.userId = this.$route.params.userId;

  }
};
</script>
